import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { setToggleFilter } from 'store/ProductCatalog/filters/actions';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

export function FilterHeader({ isMobile, className, name, isOpen, onClick }) {
  return (
    <div
      role="button"
      tabIndex={0}
      className={cx('header', className, isMobile && 'mobile', isOpen && 'opened')}
      onClick={onClick}
    >
      <span className={cx('name', isMobile && 'mobile')}>{name}</span>
    </div>
  );
}

FilterHeader.propTypes = {
  isMobile: PropTypes.bool,
  className: PropTypes.string,
  name: PropTypes.string,
  // slug: PropTypes.string, // passed as ownProp, used by react-redux
  isOpen: PropTypes.bool,
  onClick: PropTypes.func,
};

const mapDispatchToProps = (dispatch, { slug, isOpen }) => ({
  onClick: () => dispatch(setToggleFilter(slug, isOpen)),
});

export default connect(null, mapDispatchToProps)(FilterHeader);
